<template>
  <div>
    <HeadlineContainer headline="Create Retention Touchpoint" :breadcrumbs="breadcrumbs"/>

    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <HelpText>
            <h3>
              Create Retention Touchpoint
            </h3>

            <p>
              Enter the details of the retention touchpoint.
            </p>
          </HelpText>
        </div>

        <div class="col-xs-18">
          <div class="panel panel-default">
            <div class="panel-body">
              <form @submit.prevent="submit" class="form-horizontal">
                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the retention touchpoint."
                    :error="getError('name')"
                />

                <TextFormGroup
                    v-model="data.threshold"
                    name="threshold"
                    label="Threshold"
                    help-text="The number of days without content that should trigger the touchpoint."
                    :error="getError('threshold')"
                />

                <hr>

                <SubmitFormGroup button-class="btn-black"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import HelpText from '@/components/HelpText'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    HeadlineContainer,
    HelpText,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  data() {
    return {
      data: {},
    }
  },

  computed: {
    breadcrumbs() {
      return [
        {url: '/retention-touchpoints', text: 'Retention Touchpoints'},
        {text: 'Create'}
      ]
    },
  },

  methods: {
    submit() {
      http.post('/api/v2/retention-touchpoints', this.data)
          .then(() => {
            notify.success('The retention touchpoint was saved')

            this.$router.push('/retention-touchpoints')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
